$(document).on 'turbolinks:load', ->
  document.addEventListener 'dnd-upload:initialize', (event) ->
    $('.upload-info').removeClass 'd-none'

  document.addEventListener 'dnd-upload:error', (event) ->
    event.preventDefault()
    alert 'Dateityp nicht unterstützt. Bitte wählen Sie nur .pdf, .png, .jpg oder .jpeg Dateien aus.'
